import React, { useContext, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Slider from 'react-slick';
import { camelCase } from 'lodash';
import { Container } from './styles/Container.styled';
import { VisitFeature } from './styles/VisitFeature.styled';
import {
  TabWrapper,
  ButtonTab,
  TabDescription,
  Spanpt,
} from './styles/FacilitiesTabSection.styled';
import {
  Facilitiescard,
  CardDescprt,
  Titleh3,
  Descplwr,
  InfoDetails,
  ToggleTag,
  CardLogo,
  InfoDetailsPart,
  Container as ContainerF,
} from './styles/FacilitiesCard.styled';
import Sprites from './Sprites';
import LoadMoreGenericBtn from './LoadMoreGenericBtn';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';

function DetailsPart({ children, dir, id }) {
  const [isOpen, setOpen] = React.useState(false);
  const { translations } = useContext(DWTCContext);

  return (
    <div className="accordion-wrapper" dir={dir} id={id}>
      <ToggleTag
        className={`accordion-title ${isOpen ? 'open' : ''}`}
        onClick={() => setOpen(!isOpen)}
        dir={dir}
      />

      <InfoDetails className={`accordion-item ${!isOpen ? 'collapsed' : ''}`}>
        <InfoDetailsPart className="accordion-content" dir={dir}>
          {getTranslationByKey(translations, children)}
        </InfoDetailsPart>
      </InfoDetails>
    </div>
  );
}

export default function Facilities({ data, id, dir }) {
  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3500,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          arrows: false,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          autoplay: false,
          arrows: true,
          centerPadding: '70px',
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          autoplay: false,
          arrows: true,
          centerPadding: '45px',
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          slidesToShow: 1,
          autoplay: false,
        },
      },
    ],
  };

  const types = ['All Facilities', ...new Set(data.facilities.map((item) => item.content.type))];
  const [toggleState, setToggleState] = useState(types[0]);
  const [filteredFacilities, setFilteredFacilities] = useState(data.facilities);

  const [loadMore, setLoadMore] = React.useState(false);
  const [hasMore, setHasMore] = React.useState(data.facilities.length > 8);
  const [cardList, setCardList] = React.useState(
    data.facilities.length <= 8 ? data.facilities : [...data.facilities.slice(0, 8)],
  );
  const viewwebsite = dir === 'ltr' ? 'VISIT WEBSITE' : 'زيارة الموقع';
  const loadMoreButton = dir === 'ltr' ? 'Load More' : 'تحميل المزيد';

  React.useEffect(() => {
    if (toggleState === types[0]) {
      setCardList(data.facilities.length <= 8 ? data.facilities : [...data.facilities.slice(0, 8)]);
      setFilteredFacilities(data.facilities);
    } else {
      const currentFacilities = data.facilities.filter(
        (value) => value.content.type === toggleState,
      );
      setFilteredFacilities(data.facilities.filter((value) => value.content.type === toggleState));
      setCardList(
        currentFacilities.length <= 8 ? currentFacilities : [...currentFacilities.slice(0, 8)],
      );
    }
  }, [toggleState]);

  const handleLoadMore = () => setLoadMore(true);

  React.useEffect(() => {
    if (loadMore && hasMore) {
      const currentLength = +cardList.length;
      const isGrater = +currentLength < +filteredFacilities.length;
      const nextResults = isGrater
        ? filteredFacilities.slice(+currentLength, +currentLength + 8)
        : [];
      setCardList([...cardList, ...nextResults]);
      setLoadMore(false);
    }
  }, [loadMore, hasMore]);

  React.useEffect(() => {
    const isGrater = cardList.length < filteredFacilities.length;
    setHasMore(isGrater);
  }, [cardList]);

  const { translations } = useContext(DWTCContext);

  return (
    <VisitFeature id={id} className="tabgroup_section">
      <Container>
        <TabWrapper dir={dir} className="facilities_tab">
          <Slider {...settings} dir={dir}>
            {types.map((type) => (
              <ButtonTab
                className={toggleState === type ? 'tabs active-tabs' : 'tabs'}
                onClick={() => setToggleState(type)}
                dir={dir}
              >
                <Sprites name={camelCase(type)} />
                <Spanpt dir={dir}>{getTranslationByKey(translations, type)}</Spanpt>
              </ButtonTab>
            ))}
          </Slider>
        </TabWrapper>
      </Container>

      <TabDescription className="facilities_tabdescription">
        <ContainerF>
          {cardList &&
            cardList.map((facility, index) => (
              <Facilitiescard key={index}>
                <div className="card-wrapper">
                  {facility.content.logo && (
                    <CardLogo>
                      <LazyLoadImage
                        src={facility.content.logo.url}
                        width={147}
                        effect="blur"
                        alt={facility.content.title}
                        placeholderSrc={
                          facility.content.logo
                            ? `${facility.content.logo.url}?width=50&quality=50`
                            : null
                        }
                      />
                    </CardLogo>
                  )}
                  <CardDescprt>
                    <Titleh3 dir={dir}>{facility.content.title}</Titleh3>
                    <Descplwr dir={dir}>
                      <p dir={dir}>{facility.content.location}</p>
                      <p dir="ltr">{facility.content.contactNumber}</p>
                      <p dir={dir} className="time_day">
                        <time dir={dir}>
                          {facility.content.openingHours} - {facility.content.closingHours}
                        </time>
                        <br />
                        {getTranslationByKey(translations, facility.content.fromDay)}-
                        {getTranslationByKey(translations, facility.content.toDay)}
                      </p>
                      {facility.content.facilityWebsite ? (
                        <a
                          dir={dir}
                          href={facility.content.facilityWebsite}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {viewwebsite}
                        </a>
                      ) : null}
                    </Descplwr>
                  </CardDescprt>

                  <DetailsPart dir={dir}>
                    <InfoDetails dir={dir}>
                      <InfoDetailsPart dir={dir}>
                        <Titleh3 dir={dir}>{facility.content.title}</Titleh3>
                        <p dir={dir}> {facility.content.text}</p>
                      </InfoDetailsPart>
                    </InfoDetails>
                  </DetailsPart>
                </div>
              </Facilitiescard>
            ))}
          {hasMore && (
            <LoadMoreGenericBtn
              color="filledBlue"
              position="center"
              className="!mt-5"
              label={loadMoreButton}
              onClick={handleLoadMore}
              dir={dir}
            />
          )}
        </ContainerF>
      </TabDescription>
    </VisitFeature>
  );
}
